<script lang="ts" setup>
  import Icon from '@leaflink/stash/Icon.vue';

  import { ROUTE_NAMES } from '@/constants';
  import { useUserStore } from '@/piniaStores/user/user.store';

  const userStore = useUserStore();
</script>

<template>
  <router-link :to="{ name: ROUTE_NAMES.STORE_FAVORITES, params: { company: userStore.userActiveCompany?.slug } }">
    <Icon class="color-ice-700" name="heart-filled" />
  </router-link>
</template>
